// extracted by mini-css-extract-plugin
module.exports = {"container":"notification_watcher_title-module__container--3CE68"};